import styled from 'styled-components'

export const gameImageAspectRatio = 473 / 320

export const BaseGameBox = styled.div`
  padding: 0.5rem;
  max-width: 26rem;
`
